<template>
    <div class="llp-label">
        <label :aria-label="ariaLabel" :class="classNames" :for="id" class="form-label">
            <span v-if="isRequired" class="text-danger">* </span>
            <slot></slot>
        </label>
    </div>
</template>

<script>
export default {
  name: 'BaseLabel',
  props: {
    id: {
      type: String,
      required: true,
    },
    ariaLabel: {
      type: String,
      required: true,
    },
    classNames: {
      type: String,
      required: false,
      default: '',
    },
    isRequired: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
